{
  "settings": "Einstellungen",
  "yourDigitalAssistant": "Ihr digitaler Assistent",
  "getStarted": "Jetzt starten",
  "login": "Anmeldung",
  "loggingIn": "Einloggen ...",
  "darkMode": "Dark mode",
  "clearHistory": "Verlauf löschen",
  "historyCleared": "Verlauf gelöscht",
  "changeLanguage": "Sprache",
  "termsAndConditions": "Nutzungsbedingungen",
  "messagePlaceholder": "Schreiben Sie Ihre Nachricht hier ...",
  "messagePlaceholderDisabled": "Eingabe deaktiviert ...",
  "feedbackTitle": "Bewerten Sie Ihre Erfahrung",
  "feedbackPlaceholder": "Erzähl uns darüber (wahlweise)",
  "feedbackSend": "Senden",
  "feedbackClose": "Schließen",
  "sessionExpired": "Ihre Sitzung ist abgelaufen, da Sie eine Weile inaktiv waren.",
  "startNewSession": "Starten Sie eine neue Sitzung",
  "apiError": "Ups! Etwas ist schief gelaufen. Wir bemühen uns um eine schnelle Lösung.",
  "apiErrorOffline": "Sie sind nicht mit dem Internet verbunden.",
  "tryAgain": "Versuchen Sie es noch einmal",
  "startOver": "Neu starten",
  "chatEnded": "Der Chat ist beendet.",
  "chatEndedThankYou": "Vielen Dank für das Gespräch mit uns!",
  "closeChat": "Schließen",
  "startNewChat": "Chatten Sie erneut",
  "humanTakeoverStarted": "Sie werden jetzt zum Kundendienst weitergeleitet ...",
  "humanTakeoverQueued": "Warten auf eine Verbindung mit einem Agenten",
  "humanTakeoverAnAgent": "Ein Agent",
  "humanTakeoverAgentEntered": "hat das Gespräch eingegeben",
  "humanTakeoverAgentLogout": "hat die Unterhaltung verlassen",
  "humanTakeoverTransfer": "Sie werden zu einem neuen Agenten weitergeleitet",
  "humanTakeoverEnded": "Sie chatten jetzt mit Ihrem digitalen Assistenten",
  "version": "Version",
  "formIntroText": "Bitte füllen Sie das folgende Formular aus, um mit uns zu chatten.",
  "formFirstName": "Vorname",
  "formLastName": "Nachname",
  "formName": "Name",
  "formEmail": "E-Mail",
  "formWrongEmail": "Bitte geben Sie eine gültige E-Mail-Adresse an.",
  "formPhone": "Telefon",
  "formShipmentId": "Sendungs-ID",
  "formQuestion": "Ihre Frage",
  "formAccountNumber": "Kontonummer (für Geschäftskunden)",
  "formAddress": "Adresse",
  "formPostcode": "Postleitzahl",
  "formCity": "Stadt",
  "formCountry": "Land",
  "formSubmitButton": "Chat starten",
  "formEmptyFieldError": "Darf nicht leer sein.",
  "formPhoneNumberValidationError": "Keine gültige Telefonnummer.",
  "formInputIsBiggerThan50": "Darf höchstens 50 Zeichen enthalten.",
  "formInputIsBiggerThan100": "Darf höchstens 100 Zeichen enthalten.",
  "formInputIsBiggerThan2000": "Darf höchstens 2000 Zeichen enthalten.",
  "widgetEventOnline": "DA-Nachricht: Benutzer ist wieder online.",
  "widgetEventHidden": "DA-Nachricht: Widget ist versteckt.",
  "widgetEventVisible": "DA-Nachricht: Widget ist sichtbar.",
  "widgetEventVisibleMinimized": "DA-Nachricht: Widget ist sichtbar, aber minimiert.",
  "widgetEventMinimized": "DA-Nachricht: Widget wird minimiert.",
  "widgetEventMaximized": "DA-Nachricht: Widget ist maximiert.",
  "widgetEventSessionExpired": "DA-Nachricht: Widget-Sitzung abgelaufen.",
  "widgetEventHangupHuman": "DA-Nachricht: Benutzer beendet die menschliche Übernahmesitzung.",
  "widgetEventUserTyping": "DA-Nachricht: Benutzer tippt.",
  "fileTooLarge": "Sie versuchen, zu große Dateien anzuhängen.",
  "tooManyDiles": "Sie versuchen, zu viele Dateien anzuhängen.",
  "fileInvalidType": "Sie versuchen, ungültige Dateitypen anzuhängen.",
  "attachmentsDropHere": "Zum Hochladen hier oder",
  "attachmentsBrowse": "Dateien durchsuchen",
  "attachmentsExtenstionQuantity": "PDF oder Bilder (bis zu 10 Dateien)",
  "attachmentsSize": "bis zu 30 MB",
  "attachmentsFailedUploading": "Hochladen fehlgeschlagen",
  "attachmentsUploading": "Hochladen ...",
  "minimizeExpandText": "Live-Chat jetzt mit uns!",
  "popupWidgetNotificationMessage": "Sie haben eine neue Nachricht erhalten!",
  "tabWidgetNotificationMessage": "Neue Nachricht!",
  "datepickerSendButton": "Schicken"
}
